import { del, get, post, put, urlApiTegra } from "../../../service/api";

const url = urlApiTegra;

async function getTech(token: string) {
    return get(`${url}/technology`, token)
}

async function postTech(body: any, token: string) {
    return post(`${url}/technology`, body, token)
}

async function delTech(id: number, token: string) {
    return del(`${url}/technology/${id}`, token)
}

async function putTech(dadosBody: object, id: any, token: string) {
    return put(`${url}/technology/${id}`, dadosBody, token)
}

export {
    postTech,
    getTech,
    delTech,
    putTech,
}